import styled from 'styled-components';

export const MobileContainer = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    width: 100%;
    min-height: 100vh;
    background: #FFFFFF;
    padding: 16px 0;
  }
`;

export const MobileContent = styled.div`
  width: 100%;
  background: transparent;
  margin-top: 16px;
  min-height: calc(100vh - 120px);
  position: relative;
  z-index: 1;
  padding-top: 8px;
`;

export const MobileConsultantSection = styled.div`
  padding: 0 16px;
  background: #FFFFFF;
`;

export const MobileConsultantContainer = styled.div`
  background: #FFFFFF;
  border: 1px solid #CBCBCB;
  border-radius: 8px;
  margin-bottom: 24px;
  overflow: hidden;
`;

export const MobileExpandableContent = styled.div`
  display: ${props => props.expanded ? 'block' : 'none'};
  background: #FFFFFF;

  @media (max-width: 768px) {
    animation: ${props => props.expanded ? 'slideDown' : 'slideUp'} 0.3s ease;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      max-height: 0;
    }
    to {
      opacity: 1;
      max-height: 500px;
    }
  }

  @keyframes slideUp {
    from {
      opacity: 1;
      max-height: 500px;
    }
    to {
      opacity: 0;
      max-height: 0;
    }
  }
`;

export const MobileConsultantCard = styled.div`
  background: transparent;
`;

export const MobileConsultantInfo = styled.div`
  padding: 0;
`;

export const MobileDataField = styled.div`
  width: 100%;
  background-color: #FFFFFF;
  border: 1px solid #CBCBCB;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    margin-bottom: 12px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const MobileFieldHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

export const MobileFieldIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #0B29FB;
`;

export const MobileFieldLabel = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #929292;
  line-height: 1.54;
`;

export const MobileFieldValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-left: 36px;
`;

export const MobileFieldText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #3D3D3D;
  line-height: 1.54;
`;

export const MobileRatingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const MobileRatingStar = styled.span`
  color: #FFCB45;
  font-size: 16px;
`;

export const MobileRatingText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #3D3D3D;
`;

export const MobileSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding: 16px;
  cursor: pointer;
  border-bottom: ${props => props.isExpanded ? 'none' : '1px solid #E9ECEF'};
`;

export const MobileSectionHeaderTitle = styled.h3`
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #3D3D3D;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MobileExpandIcon = styled.div`
  transform: ${props => props.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: transform 0.3s ease;

  svg {
    width: 20px;
    height: 20px;
    color: #3D3D3D;
  }
`;

export const MobileFieldCard = styled.div`
  background: #FFFFFF;
  border: none;
  border-bottom: 1px solid #F5F5F5;
  border-radius: 0;
  padding: 16px;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: none;

  &:last-child {
    border-bottom: none;
  }
`;

export const MobileCardIcon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #EEF0FD;
  border-radius: 6px;
  flex-shrink: 0;

  img {
    width: 18px;
    height: 18px;
    filter: brightness(0) saturate(100%) invert(22%) sepia(95%) saturate(2900%) hue-rotate(230deg) brightness(103%) contrast(103%);
  }
`;
export const MobileCardContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const MobileCardLabel = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #3D3D3D;
  flex: 1;
`;
export const ChevronUpIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
  </svg>
);

export const PersonIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
  </svg>
);

export const EmailIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
  </svg>
);

export const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
  </svg>
);

export const MobileVisitsHistoryContainer = styled.div`
  background: #FFFFFF;
  border: 1px solid #CBCBCB;
  border-radius: 8px;
  margin-bottom: 24px;
  overflow: hidden;
`;

export const MobileVisitsSectionTitle = styled.h2`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.54em;
  color: #3D3D3D;
  margin: 0 0 16px 0;
  padding: 0;
`;

export const MobileFiltersContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

export const MobileFilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #FFFFFF;
  border: 1px solid #D9D9D9;
  border-radius: 5px;
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #3D3D3D;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #CBCBCB;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const MobileVisitsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
`;

export const MobileVisitCard = styled.div`
  background: #FFFFFF;
  border: 1px solid #CBCBCB;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`;

export const MobileVisitEyeIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const MobileVisitContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MobileVisitDate = styled.div`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.54em;
  color: #636363;
`;

export const MobileVisitRatingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0;
`;

export const MobileVisitStars = styled.div`
  display: flex;
  gap: 2px;
`;

export const MobileVisitStar = styled.img`
  width: 14px;
  height: 14px;
  opacity: ${props => props.isActive ? 1 : 0.3};
  filter: ${props => props.isActive ? 'none' : 'grayscale(100%)'};
`;

export const MobileVisitRatingNumber = styled.div`
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #3D3D3D;
  background: #F0F0F0;
  padding: 4px 8px;
  border-radius: 8px;
`;

export const MobileVisitRatingText = styled.div`
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #0B29FB;
  cursor: pointer;
`;

export const MobileVisitStatus = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const MobileVisitStatusBadge = styled.div`
  padding: 4px 8px;
  border-radius: 8px;
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 12px;
  text-align: center;

  ${props => {
    switch(props.status) {
      case 'Realizado':
        return `
          background: #EAF7EE;
          color: #3DA464;
        `;
      case 'Agendada':
        return `
          background: #FFF3DC;
          color: #ED9500;
        `;
      case 'Cancelado':
        return `
          background: #FCEDE9;
          color: #E74141;
        `;
      default:
        return `
          background: #F0F0F0;
          color: #3D3D3D;
        `;
    }
  }}
`;

export const MobileVisitWaitingText = styled.div`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #636363;
`;

export const MobilePaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #FFFFFF;
  border: 1px solid #E9ECEF;
  border-radius: 8px;
  margin: 16px 0;
`;

export const MobilePaginationLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MobilePaginationDropdown = styled.select`
  width: 50px;
  height: 32px;
  border: 1px solid #E1E2E3;
  border-radius: 4px;
  background: #FFFFFF;
  font-family: 'Mangueira', sans-serif;
  font-size: 11px;
  color: #3D3D3D;
  cursor: pointer;
  padding: 0 8px;

  &:focus {
    outline: none;
    border-color: #CBCBCB;
  }
`;

export const MobilePaginationText = styled.div`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #3D3D3D;
`;

export const MobilePaginationRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MobilePaginationButton = styled.button`
  width: 32px;
  height: 32px;
  border: 1px solid #E1E2E3;
  border-radius: 4px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    border-color: #CBCBCB;
    background: #F8F9FA;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const MobileFiltersModal = styled.div`
  display: ${props => props.show ? 'block' : 'none'};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  z-index: 9999;
  overflow-y: auto;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const MobileFiltersModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #FFFFFF;
  border-bottom: 1px solid #E9ECEF;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const MobileFiltersBackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  color: #3D3D3D;
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
`;

export const MobileFiltersTitle = styled.h2`
  font-family: 'Mangueira', sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: #3D3D3D;
  margin: 0;
`;

export const MobileFiltersClearButton = styled.button`
  background: transparent;
  border: none;
  color: #0B29FB;
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: #0920d9;
  }
`;

export const MobileFiltersModalContent = styled.div`
  padding: 24px 20px 100px;
`;

export const MobileFiltersModalRow = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const MobileFiltersModalLabel = styled.div`
  font-family: 'Mangueira', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #3D3D3D;
  margin-bottom: 12px;
`;

export const MobileMotiveDropdown = styled.div`
  position: relative;
  width: 100%;
`;

export const MobileMotiveDropdownButton = styled.button`
  width: 100%;
  height: 56px;
  border: 1px solid #CBCBCB;
  border-radius: 12px;
  background: #FFFFFF;
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #3D3D3D;
  text-align: left;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  &:hover {
    border-color: #999999;
  }
`;

export const MobileDateInput = styled.div`
  position: relative;
  width: 100%;
  height: 56px;
  border: 1px solid #CBCBCB;
  border-radius: 12px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const MobileDateInputIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  color: #CBCBCB;
`;

export const MobileDateInputText = styled.div`
  flex: 1;
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: ${props => props.hasValue ? '#3D3D3D' : '#999999'};
  padding: 0 16px 0 16px;
`;

export const MobileDateInputHidden = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;

export const MobileStatusPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const MobileStatusPill = styled.button`
  padding: 12px 20px;
  border: 1px solid ${props => props.isSelected ? '#0B29FB' : '#E9ECEF'};
  border-radius: 24px;
  background: ${props => props.isSelected ? '#0B29FB' : '#FFFFFF'};
  color: ${props => props.isSelected ? '#FFFFFF' : '#3D3D3D'};
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.isSelected ? '#0B29FB' : '#F8F9FA'};
  }
`;

export const MobileRatingSliderContainer = styled.div`
  padding: 20px 0;
`;

export const MobileRatingSliderHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const MobileRatingSliderControl = styled.button`
  width: 40px;
  height: 40px;
  border: 1px solid #E9ECEF;
  border-radius: 50%;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #3D3D3D;
  font-size: 20px;
  font-weight: 400;

  &:hover {
    background: #F8F9FA;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const MobileRatingSliderValue = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #3D3D3D;
`;

export const MobileRatingSliderTrack = styled.div`
  position: relative;
  width: 100%;
  height: 6px;
  background: #E9ECEF;
  border-radius: 3px;
  margin: 16px 0;
`;

export const MobileRatingSliderProgress = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #0B29FB;
  border-radius: 3px;
  width: ${props => props.progress}%;
  transition: width 0.2s;
`;

export const MobileRatingSliderThumb = styled.div`
  position: absolute;
  top: 50%;
  left: ${props => props.position}%;
  width: 20px;
  height: 20px;
  background: #0B29FB;
  border: 2px solid #FFFFFF;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const MobileFiltersModalFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #FFFFFF;
  border-top: 1px solid #E9ECEF;
  padding: 20px;
  z-index: 10;
`;

export const MobileFiltersApplyButton = styled.button`
  width: 100%;
  height: 56px;
  background: #0B29FB;
  border: none;
  border-radius: 12px;
  color: #FFFFFF;
  font-family: 'Mangueira', sans-serif;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;

  &:hover {
    background: #0920d9;
  }
`;

export const MobileMotiveModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  z-index: 10000;
  display: ${props => props.show ? 'flex' : 'none'};
  flex-direction: column;
  transform: ${props => props.show ? 'translateX(0)' : 'translateX(100%)'};
  transition: transform 0.3s ease-in-out;
`;

export const MobileMotiveModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #FFFFFF;
  border-bottom: 1px solid #E9ECEF;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const MobileMotiveModalBackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  color: #3D3D3D;
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
`;

export const MobileMotiveModalTitle = styled.h2`
  font-family: 'Mangueira', sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: #3D3D3D;
  margin: 0;
`;

export const MobileMotiveModalCloseButton = styled.button`
  background: transparent;
  border: none;
  color: #3D3D3D;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MobileMotiveModalContent = styled.div`
  padding: 24px 20px;
  flex: 1;
  overflow-y: auto;
`;

export const MobileMotiveDropdownDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #E9ECEF;
  border-radius: 8px;
  background: #FFFFFF;
  margin-bottom: 24px;
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  color: #3D3D3D;
  cursor: pointer;
`;

export const MobileMotivesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: slideDown 0.3s ease-in-out;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const MobileMotiveItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  border-bottom: 1px solid #F5F5F5;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }
`;

export const MobileMotiveCheckbox = styled.input`
  width: 20px;
  height: 20px;
  border: 2px solid #E9ECEF;
  border-radius: 4px;
  cursor: pointer;
  appearance: none;
  position: relative;

  &:checked {
    background: #0B29FB;
    border-color: #0B29FB;
  }

  &:checked::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 12px;
    font-weight: bold;
  }
`;

export const MobileMotiveLabel = styled.label`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #3D3D3D;
  cursor: pointer;
  flex: 1;
`;

export const MobileMotiveModalFooter = styled.div`
  padding: 20px;
  background: #FFFFFF;
  border-top: 1px solid #E9ECEF;
  position: sticky;
  bottom: 0;
  z-index: 10;
`;

export const MobileMotiveConfirmButton = styled.button`
  width: 100%;
  padding: 16px;
  background: #0B29FB;
  border: none;
  border-radius: 8px;
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #0920d9;
  }
`;

export const MobileVisitDetailsModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  z-index: 10001;
  display: ${props => props.show ? 'flex' : 'none'};
  flex-direction: column;
  overflow-y: auto;

  @media (min-width: 769px) {
    background: rgba(0, 0, 0, 0.5);
    display: ${props => props.show ? 'flex' : 'none'};
    align-items: center;
    justify-content: center;
    padding: 20px;
  }
`;

export const MobileVisitDetailsContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;

  @media (min-width: 769px) {
    width: 90%;
    max-width: 800px;
    height: auto;
    max-height: 90vh;
    border-radius: 8px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  }
`;

export const MobileVisitDetailsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #FFFFFF;
  position: sticky;
  top: 0;
  z-index: 10;

  @media (max-width: 768px) {
    border-bottom: none;
    justify-content: flex-start;
  }

  @media (min-width: 769px) {
    position: relative;
    border-radius: 8px 8px 0 0;

  }
`;

export const MobileVisitDetailsTitle = styled.h2`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #3D3D3D;
  margin: 0;

  @media (max-width: 768px) {
    flex: 1;
    text-align: left;
  }
`;

export const MobileVisitDetailsCloseButton = styled.button`
  background: transparent;
  border: none;
  color: #3D3D3D;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    margin-left: auto;
  }
`;

export const MobileVisitDetailsContent = styled.div`
  padding: 24px 20px;
  flex: 1;

  @media (min-width: 769px) {
    max-height: 80vh;
    overflow-y: auto;
    border-radius: 0 0 8px 8px;
  }
`;

export const MobileVisitDetailsStatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  background: #EAF7EE;
  border-radius: 8px;
  margin-bottom: 24px;

  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #3DA464;
`;

export const MobileVisitMainCard = styled.div`
  background: #FFFFFF;
  border: 1px solid #CBCBCB;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  text-align: center;
`;

export const MobileVisitStarsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 5.27px;
  margin-bottom: 16px;
`;

export const MobileVisitDetailsStar = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.2s ease;

  &::before {
    content: '★';
    font-size: 28px;
    color: ${props => props.filled ? '#FFB800' : '#E0E0E0'};
  }
`;

export const MobileVisitDateTime = styled.div`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #CBCBCB;
  margin-bottom: 16px;
`;

export const MobileVisitTagsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

export const MobileVisitTag = styled.div`
  padding: 4px 8px;
  background: #FFFFFF;
  border: 1px solid #CBCBCB;
  border-radius: 8px;
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #3D3D3D;
  height: 29px;
  display: flex;
  align-items: center;
`;

export const MobileVisitDescription = styled.div`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #3D3D3D;
  line-height: 1.5;
  text-align: left;
`;

export const MobileVisitSection = styled.div`
  background: #FFFFFF;
  border: 1px solid #CBCBCB;
  border-radius: 8px;
  padding: 24px 16px;
  margin-bottom: 24px;
`;

export const MobileVisitSectionTitle = styled.h3`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #3D3D3D;
  margin: 0 0 24px 0;
`;

export const MobileConsultantRatingGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
`;

export const MobileConsultantRatingRow = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const MobileConsultantRatingSquare = styled.div`
  width: 32px;
  height: 32px;
  background: ${props => props.filled ? '#7D7D7D' : '#F2F2F2'};
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
`;

export const MobileResumoInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`;

export const MobileResumoIcon = styled.div`
  width: 24px;
  height: 24px;
  color: #3D3D3D;
  flex-shrink: 0;
`;

export const MobileResumoText = styled.div`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #3D3D3D;
  line-height: 1.5;
  flex: 1;
`;

export const MobilePlanoAcaoSection = styled.div`
  margin-bottom: 25px;

  &:not(:last-child) {
    border-bottom: 1px solid #CBCBCB;
    padding-bottom: 25px;
  }
`;

export const MobilePlanoAcaoTitle = styled.h4`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 12px;
  color: #3D3D3D;
  margin: 0 0 9px 0;
`;

export const MobilePlanoAcaoText = styled.div`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #3D3D3D;
  line-height: 1.5;
`;

export const MobileVisitDetailsSectionSubtitle = styled.h4`
  font-family: 'Mangueira', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #636363;
  margin: 0 0 16px 0;
`;
